import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconStrom: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
         y="0px"
         viewBox="0 0 104.5 117.6" style={{ color }} xmlSpace="preserve">
      <path d="M56.4,90.5h11.1v7.9c-0.3,8.4-7.3,14.9-15.7,14.7c-3.5-0.1-6.8-1.4-9.4-3.7c-0.5-0.4-0.9-0.9-1.4-1.4
        c-2.4-2.7-3.8-6.1-3.9-9.6v-7.9H50 M52.2,0L52.2,0C30.8,0.2,13.5,17.3,13,38.7C12.9,49.6,17.4,60,25.3,67.4
        c4.3,3.6,6.8,8.7,7.1,14.2v16.9c0.1,4.5,1.7,8.8,4.7,12.2c3.7,4.3,9.2,6.8,14.9,6.8h0.4c5.7,0,11.1-2.5,14.9-6.8
        c2.9-3.4,4.6-7.7,4.7-12.2V81.7c0.3-5.5,2.9-10.7,7.1-14.2c8-7.4,12.4-17.8,12.3-28.7C91,17.4,73.7,0.2,52.3,0H52.2 M50,86H37v-3.2
        c0.1-7.2-2.9-14.1-8.4-18.8c-11.5-10.6-14.3-27.7-6.8-41.4c3-5.5,7.5-10,12.9-13.2c5.3-3.1,11.4-4.9,17.5-5c6.2,0.2,12.2,1.9,17.5,5
        c5.4,3.1,9.9,7.7,12.9,13.2c7.5,13.7,4.7,30.8-6.8,41.4c-5.4,4.7-8.5,11.6-8.4,18.8V86h-13 M2.3,6.4C1,6.4,0,7.4,0,8.6
        c0,0.6,0.2,1.2,0.7,1.6l5.7,5.6c0.9,0.8,2.4,0.8,3.2-0.2c0.8-0.9,0.8-2.2,0-3l0,0L3.9,7.1C3.5,6.6,2.9,6.4,2.3,6.4 M102.2,6.4
        c-0.6,0-1.2,0.2-1.6,0.7l-5.7,5.6c-0.9,0.9-0.9,2.3,0,3.2c0,0,0,0,0,0l0,0c0.9,0.9,2.3,0.9,3.2,0l5.7-5.6c0.9-0.9,0.9-2.3,0.1-3.2
        C103.4,6.6,102.8,6.3,102.2,6.4 M52.3,9.2c-1.2,0-2.2,1-2.2,2.3s1,2.2,2.3,2.2c1.2,0,2.2-1,2.2-2.3c0,0,0,0,0,0
        c0-0.6-0.2-1.2-0.7-1.6C53.4,9.4,52.9,9.2,52.3,9.2 M61.3,10.6c-1.2,0-2.3,0.9-2.3,2.2c0,1,0.6,1.9,1.5,2.2
        c5.5,1.9,10.2,5.6,13.3,10.6c0.7,1,2.1,1.3,3.2,0.6l0.1-0.1c0.8-0.7,1.1-1.8,0.6-2.8c-3.7-5.9-9.3-10.4-15.9-12.6L61.3,10.6
         M96.5,80.2c-1.2,0-2.3,1-2.3,2.2c0,0.6,0.2,1.2,0.7,1.7l5.7,5.7c0.9,0.9,2.3,0.9,3.2,0s0.9-2.3,0-3.2l0,0l-5.7-5.7
        C97.7,80.4,97.1,80.2,96.5,80.2 M8,80.2c-0.6,0-1.2,0.2-1.6,0.7l-5.7,5.7c-0.9,0.9-0.9,2.3,0,3.2l0,0c0.9,0.9,2.3,0.9,3.2,0l5.7-5.6
        c0.9-0.9,0.9-2.3,0-3.2C9.2,80.5,8.6,80.2,8,80.2" fill="currentColor" />
    </svg>
  );
};
